import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { calculateWidth } from '../../../utils/calculateColumnWidth';
import { componentMapping } from '../../../utils/helpers';

const renderComponent = (
  component,
  length,
  groupRowTitle,
  page,
  restrictContent,
) => {
  if (component.identifier) {
    const Template = componentMapping[component.identifier];
    if (!Template) return React.Fragment;
    return (
      <Template
        {...component}
        page={page}
        columnsLength={length}
        groupRowTitle={groupRowTitle}
        restrictContent={restrictContent}
      />
    );
  }
  return null;
};

export const createFlexTemplate = (
  item,
  columns,
  columnMargin,
  contentAlignment,
  groupRowTitle,
  page,
  restrictContent,
) => {
  let justifyContent;

  switch (contentAlignment) {
    case 'center':
      justifyContent = 'center';
      break;
    case 'right':
      justifyContent = 'flex-end';
      break;
    default:
      justifyContent = 'flex-start';
  }

  return (
    <Flex
      id={item.id}
      key={item.id}
      width={calculateWidth(columns)}
      justifyContent={justifyContent}
      {...columnMargin}
    >
      {renderComponent(
        item,
        columns.length,
        groupRowTitle,
        page,
        restrictContent,
      )}
    </Flex>
  );
};

export const createBoxTemplate = (
  item,
  columns,
  groupRowTitle,
  page,
  restrictContent,
) => (
  <Box id={item.id} key={item.id} width={1}>
    {renderComponent(
      item,
      columns.length,
      groupRowTitle,
      page,
      restrictContent,
    )}
  </Box>
);
